import api                   from '../../../../../api';
import Context from '../../../../../context';
import React                 from 'react';
import values                from '../../../../../values';
import TransactionsScreen    from '../../../../../context/Transactions.context';
import FindTransactionScreen from '..';

import { TModal            } from '../../../../../types/common.type';
import { useQuery          } from 'react-query';
import { IFindTransactions } from '../../../../../types/common.interface';

const FindTransactionContainer = () => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [showModal, setShowModal] = React.useState<TModal>("NONE");
  const [selectedTransaction, setSelectedTransaction] = React.useState<any>();

  const [requestTransaction, setRequestTransaction] =
    React.useState<IFindTransactions>({
      page: 1,
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
      filters: {},
    });

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  // ? Panel-wide academic year (سال تحصیلی). It has to be part of the query key as well as the request, otherwise
  // ? react-query serves the previous year's cached rows when the year is switched.
  const { selectedYear } = React.useContext(Context.AcademicYear);

  const getAllTransaction = useQuery(
    [values.useQueryKeys.getAllTransactions, requestTransaction, selectedYear?._id],
    () => api.post.common.findTransaction({ ...requestTransaction, academicYear: selectedYear?._id })
  );

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <TransactionsScreen.Provider
      value={{
        isLoading          ,
        showModal          ,
        requestTransaction ,
        selectedTransaction,
        setIsLoading          ,
        setShowModal          ,
        setRequestTransaction ,
        setSelectedTransaction,
      }}
    >
      <FindTransactionScreen rqData={getAllTransaction} showModalData={{}} />
    </TransactionsScreen.Provider>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default FindTransactionContainer;
